import { Component, OnInit } from '@angular/core';
import { AbstractComponent } from '../abstract-component';
import { EncounterAttendenceService } from 'src/app/modules/provider-management/services/encounter-attendence.service';
import { takeUntil } from 'rxjs';
import { LoadingService } from 'src/app/services/loading.service';
import { IEncounterSubmissionDetail } from '../../interfaces/encounter-submission-detail';

@Component({
  selector: 'app-view-encounter-submission-details',
  templateUrl: './view-encounter-submission-details.component.html',
  styleUrls: ['./view-encounter-submission-details.component.scss'],
  standalone: false,
})
export class ViewEncounterSubmissionDetailsComponent
  extends AbstractComponent
  implements OnInit
{
  public encounterSk: string;
  public submissionDetails: IEncounterSubmissionDetail[];
  readonly statusCreated: number = 1;
  readonly statusDraft: number = 2;
  readonly statusModified: number = 3;
  readonly statusCertified: number = 4;
  readonly statusApproved: number = 5;
  readonly statusRejected: number = 6;
  readonly statusOverdue: number = 7;
  readonly statusInReview: number = 8;

  constructor(
    private encounterService: EncounterAttendenceService,
    private laodingService: LoadingService
  ) {
    super();
  }

  ngOnInit(): void {
    this.laodingService.show();
    this.getSubmissionDetails();
  }

  getSubmissionDetails(): void {
    this.encounterService
      .getSubmissionDetails(this.encounterSk)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((data: IEncounterSubmissionDetail[]) => {
        this.laodingService.hide();
        this.submissionDetails = data;
      });
  }

  getActionText(statusId: number): string {
    switch (statusId) {
      case this.statusCreated:
        return 'Created';
      case this.statusDraft:
        return 'Created'; // Draft usually shows as Created
      case this.statusModified:
        return 'Modified';
      case this.statusCertified:
        return 'Certified';
      case this.statusApproved:
        return 'Approved';
      case this.statusRejected:
        return 'Rejected';
      case this.statusOverdue:
        return 'Overdue';
      case this.statusInReview:
        return 'In Review';
      default:
        return '';
    }
  }

  override afterOnDestroy(): void {
    //
  }
}
